module.exports = __webpack_public_path__ + "static/media/PayStar.a0aaf778.svg";